import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=505680f0"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports